import { IBerechnung } from "./IBerechnung";

export class Berechnung implements IBerechnung {
    berechnungID: number;
    berechnung: string;
    bnk: number;
    bnk14: number;
    bnk59: number;
    readonly: boolean;

    constructor() {
        this.berechnungID = 0;
        this.berechnung = '';
        this.bnk = 0;
        this.bnk14 = 0;
        this.bnk59 = 0;
        this.readonly = false;
    }

    // constructor(
    //     berechnungID: number,
    //     berechnung: string,
    //     bnk: number,
    //     bnk14: number,
    //     bnk59: number,
    //     readonly: boolean
    // ) {
    //     this.berechnungID = berechnungID;
    //     this.berechnung = berechnung;
    //     this.bnk = bnk;
    //     this.bnk14 = bnk14;
    //     this.bnk59 = bnk59;
    //     this.readonly = readonly;
    // }
}
